import configAPI from 'services/api/configAPI';
import ConfigurationActions from '../../../store/configurationRedux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const api = configAPI.create();
const ConfigInitializer = ( {updateState}) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const controller = new AbortController();

        const loadConfig = async () => {
            try {
                const response = await api.getConfig();
                if(controller.signal.aborted) return;
                const configData = response.data;
                dispatch(ConfigurationActions.setConfiguration(configData));

                var heapAppId = localStorage.getItem('spark_heap_app_id');

                if (heapAppId !== configData.heap_application_id && configData.heap_application_id) {
                    localStorage.setItem('spark_heap_app_id', configData.heap_application_id)
                    window.heap.load(configData.heap_application_id, {
                        disableTextCapture: true
                    })
                }

                var tpsBaseUri = localStorage.getItem('tps_base_uri');

                if (tpsBaseUri !== configData.tps_base_uri && configData.tps_base_uri) {
                    localStorage.setItem('tps_base_uri', configData.tps_base_uri)
                }

                var tpsBaseUriFranchise = localStorage.getItem('tpsc_base_uri_franchise');

                if (tpsBaseUriFranchise !== configData.tpsc_base_uri_franchise && configData.tpsc_base_uri_franchise) {
                    localStorage.setItem('tpsc_base_uri_franchise', configData.tpsc_base_uri_franchise)
                }

                var autoassignableProducts = localStorage.getItem('autoassignable_products');

                if (autoassignableProducts !== configData.autoassignable_products && configData.autoassignable_products) {
                    localStorage.setItem('autoassignable_products', configData.autoassignable_products)
                }
                updateState("configInitializer");
            } catch (error) {
                if (!controller.signal.aborted) {
                    console.log("ConfigInitializer: Failed to load configuration.", { file: "ConfigInitializer.js" }, error);
                }
            }
        };

        loadConfig();

        return () => {
            controller.abort();
        };
    }, []);
    return null;
};

export default ConfigInitializer;